// frontend/src/components/VendorResourceContactLink.jsx
// Project: Vision ANPR by Castle Traffic Ltd
// Author: Castle Traffic Ltd
// Created: 2026-10-28 GMT
// Updated: 2026-10-28 GMT
// Stage 2B: Explicit vendor resource -> company contact creation/linkage.
// No portal account is created; frontend cannot choose tenant/company for API.
import React, { useEffect, useState } from "react";
import api from "../api/axiosInstance";

export default function VendorResourceContactLink({ resourceId, enabled = true, onPreferenceChange }) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [chosen, setChosen] = useState(true);
  useEffect(() => {
    let alive = true;
    if (!resourceId || !enabled) { setStatus(null); return () => { alive = false; }; }
    api.get(`/resources/${resourceId}/vendor-contact`)
      .then(({ data }) => { if (alive) { setStatus(data); setError(""); } })
      .catch((e) => { if (alive) setError(e?.response?.data?.detail || "Cannot load company contact status"); });
    return () => { alive = false; };
  }, [resourceId, enabled]);
  if (!enabled) return null;
  const linked = Boolean(status?.linked);
  const invoke = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/resources/${resourceId}/vendor-contact`, {});
      const latest = await api.get(`/resources/${resourceId}/vendor-contact`);
      setStatus(latest.data);
      if (!data.linked) setError("Link not confirmed");
    } catch (e) { setError(e?.response?.data?.detail || "Unable to create or link company contact"); }
    finally { setBusy(false); }
  };
  return <div style={{ gridColumn: "1 / -1", padding: 10, border: "1px solid #bbb", borderRadius: 8, marginTop: 6 }}>
    <strong>Vendor company contact</strong>
    {linked ? <p style={{ margin: "6px 0" }}>Linked: {status.contact?.first_name} {status.contact?.last_name} ({status.contact?.email})</p>
      : resourceId ? <div style={{ marginTop: 8 }}>
        <label><input type="checkbox" checked={chosen} onChange={e => { setChosen(e.target.checked); onPreferenceChange?.(e.target.checked); }} /> Create company contact from resource</label>
        <div style={{ marginTop: 8 }}><button type="button" disabled={!chosen || busy || !status} onClick={invoke}>
          {busy ? "Linking…" : "Create / link company contact now"}
        </button></div>
      </div>
      : <label style={{ display: "block", marginTop: 8 }}><input type="checkbox" checked={chosen} onChange={e => { setChosen(e.target.checked); onPreferenceChange?.(e.target.checked); }} /> Create company contact after saving resource</label>}
    {error && <div role="alert" style={{ color: "#b42318" }}>{String(error)}</div>}
    <small>No portal access is granted. Existing matching company contacts are reused.</small>
  </div>;
}
